/**
 * Copyright 2015-present Isshoikka. All Rights Reserved.
 *
 */

const IsshoikkaPlantActionConstants = {
    LOAD_ALL: "read_all",
    LOAD_ALL_WITH_ARRANGEMENT_ID: "load_all_with_arrangement_id",
    LOAD_BY_ARRANGEMENT_ID: "read_by_arragement_id",
};

export default IsshoikkaPlantActionConstants;
